import { APP_NAME_MAP, DeviceUserApp } from '@/configu/appName';
import hostMap, { Host, HOST_MAP } from '@/configu/hostMap';
import { MicroApp } from '@ecoflow/ef-micro';
import { useState } from 'react';
import { useMount } from 'ahooks';
import { getUserLinkProduct } from './api';

export default function App() {
    const [loading, setLoading] = useState<boolean>(true);
    const [name, setName] = useState<string>(DeviceUserApp.JT);
    const [url, setUrl] = useState<string>(Host.JT);

    /**
     * @Todo
     * 1.判断需要进入的微应用
     * - 非登录，进 JT
     * - 单产品
     * - 多产品
     */

    useMount(() => {
        /**
         * @userInfo
         * 1、有 JWT
         *  -> 401/非 200 -> 登录失效 -> JT Micro -> Micro Login
         *  -> 200 ->
         *
         *
         *  Micro Login -> 鉴权成功 -> reload
         *
         *
         *
         *  -> 200
         *          -> unlink -> JT Micro
         *          -> link ->
         */
        //
        getUserLinkProduct()
            .then(({ code, data }) => {
                if (code === '0' && data) {
                    const { propertyValue } = data;

                    const microName = propertyValue && APP_NAME_MAP[propertyValue] ? APP_NAME_MAP[propertyValue] : DeviceUserApp.JT;
                    setName(microName);

                    const microUrl = propertyValue && HOST_MAP[propertyValue] ? HOST_MAP[propertyValue] : Host.JT;
                    setUrl(microUrl);
                }

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    });

    if (loading) return <></>;

    console.log('【name】', name, url);

    return <MicroApp name={name} url={hostMap(url)} disable-memory-router disable-scopecss />;
}
